export default __webpack_public_path__ + "static/media/2425 knife block B top.b94c8fcd.png";